import axios from "axios";
import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import TransactionFields from "./TransactionFields";
import { buildPayload, formFromTransaction, useDateRate, validate } from "../lib/transactionForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EditTransactionDialog({ transaction, groups, accounts, onClose, onSaved }) {
  const [form, setForm] = useState(null);
  const [notice, setNotice] = useState("");
  const dateRate = useDateRate(form?.transaction_date);

  useEffect(() => {
    setForm(transaction ? formFromTransaction(transaction) : null);
    setNotice("");
  }, [transaction]);

  const setField = (key, value) => setForm(current => ({ ...current, [key]: value }));

  const save = async event => {
    event.preventDefault();
    const error = validate(form);
    if (error) { setNotice(error); return; }
    try {
      const sameCcy = form.transaction_date === transaction.transaction_date && form.currency === transaction.currency;
      const keepRate = form.transaction_date === transaction.transaction_date ? transaction.rate : dateRate.rate;
      const payload = buildPayload(form, keepRate, dateRate.rates);
      if (sameCcy) payload.currency_rate = transaction.currency_rate || payload.currency_rate;
      await axios.put(`${API}/transactions/${transaction.id}`, payload);
      onSaved?.();
      onClose();
    } catch {
      setNotice("Kayıt güncellenemedi");
    }
  };

  return (
    <Dialog open={!!transaction} onOpenChange={open => !open && onClose()}>
      <DialogContent className="edit-dialog" data-testid="edit-transaction-dialog">
        <DialogHeader>
          <DialogTitle>Kaydı düzenle</DialogTitle>
          <DialogDescription>Yanlış girilen bilgiyi düzeltin; değişiklik işlem günlüğüne yazılır.</DialogDescription>
        </DialogHeader>
        {form && (
          <form onSubmit={save} className="edit-form">
            <TransactionFields form={form} setField={setField} groups={groups} accounts={accounts} dateRate={dateRate} idPrefix="edit-"/>
            <div className="dialog-actions">
              <button type="button" className="outline-btn" data-testid="edit-cancel-button" onClick={onClose}>Vazgeç</button>
              <button type="submit" className="primary-btn" data-testid="edit-save-button"><Save size={16}/> Kaydet</button>
            </div>
            {notice && <div className="notice error" data-testid="edit-notice">{notice}</div>}
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
